<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="module__content">
      <div class="swiper" id="featureSwiper">
        <div class="swiper-wrapper">
          <div
            v-for="(image, key) in imageList"
            :key="key"
            class="swiper-slide"
          >
            <div class="img-box">
              <img @load="handleLoad(image)" :src="image.url" />
              <loader class="loader" width="91.6vw" height="105.6vw" v-if="image.imageLoading"></loader>
            </div>
          </div>
        </div>
        <div class="swiper-navigation swiper-button__prev"></div>
        <div class="swiper-navigation swiper-button__next"></div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min.mjs'
import 'swiper/swiper-bundle.css'

import Loader from '@/components/loader/Index.vue'

import featureMixins from '@/mixins/home/featureMixins.js'

export default {
  name: 'MobileHomeFeature',
  mixins: [featureMixins],
  components: {
    Loader,
  },
  methods: {
    initSwiper() {
      this.$nextTick(() => {
        const stretch = document.documentElement.offsetWidth / 2.941176 // 750宽度下stretch为255，根据屏幕宽度计算stretch
        this.swiper = new Swiper('#featureSwiper', {
          direction: 'horizontal',
          loop: true,
          slidesPerView: 1.506578,
          centeredSlides: true,
          effect: "coverflow",
          coverflowEffect: {
            rotate: 0,
            stretch: stretch,
            depth: 300,
            modifier: 1,
            slideShadows: false,
          },
          pagination: {
            el: '.swiper-pagination',
            bulletClass: 'swiper-pagination__btn',
            bulletActiveClass: 'swiper-pagination--active',
            clickable: true,
            renderBullet: function (index, className) {
              return '<div class="' + className + '"></div>'
            }
          },
          navigation: {
            prevEl: '.swiper-button__prev',
            nextEl: '.swiper-button__next',
          },
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.module {
  height: 166.8vw;

  &__title {
    background-position: center -116.266666vw;
  }

  &__content {
    position: relative;
    width: 100%;
    height: 118vw;
    overflow: hidden;
  }
}

.swiper {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 4.8vw;
  width: 91.6vw;
  height: 105.6vw ;
  overflow: visible;

  .swiper-slide {
    position: relative;
    height: 105.6vw;
    opacity: 0;

    ::v-deep .img-box {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 60.8vw;
      height: 105.6vw;
      background: url('~@/assets/img/mobile/feature_bg.png') no-repeat;
      background-size: 100%;

      .loader {
        position: absolute;
      }
    }
  }

  ::v-deep .swiper-slide-active {
    z-index: 1;
    opacity: 1;
  }

  ::v-deep .swiper-slide-prev,
  ::v-deep .swiper-slide-next {
    opacity: 1;
    // transition: all .3s;

    .img-box::after {
      content: '';
      position: absolute;
      z-index: 1;
      width: 57.6vw;
      height: 102.4vw;
      background: #000;
      opacity: 0.5;
    }
  }

  // ::v-deep .swiper-slide-next {
  //   transform: translateX(-45vw) scale(.9);
  // }
  // ::v-deep .swiper-slide-prev {
  //   transform: translateX(45vw) scale(.9);
  // }

  ::v-deep img {
    width: 57.6vw;
    height: 102.4vw;
  }

  .swiper-pagination {
    position: absolute;
    bottom: -7.6vw;
    display: flex;
    justify-content: center;

    ::v-deep .swiper-pagination__btn {
      display: block;
      margin: 0 1.333333vw;
      width: 3.333333vw;
      height: 3.333333vw;
      background: url('~@/assets/img/common/news_swiper.png') no-repeat;
      background-size: 100%;
      background-position: 0 0;
    }

    ::v-deep .swiper-pagination--active {
      background-position: 0 -3.333333vw;
    }
  }

  .swiper-navigation {
    position: absolute;
    z-index: 1;
    top: 48.533333vw;
    width: 10.266666vw;
    height: 8.666666vw;
    background: url('~@/assets/img/mobile/swiper_arrow.png') no-repeat;
    background-size: 20.533333vw 100%;

    &.swiper-button__prev {
      left: 4vw;
    }

    &.swiper-button__next {
      right: 4vw;
      background-position: -10.266666vw;
    }
  }
}
</style>